
export default {
  props: {
    listObject: {
      type: Object,
      default: () => {},
    },
  },
};
